<template>
<div class="tw-text-sm font-normal">
    <div v-for="(key, value) in formResultStore.formResult.form_data.holidays">
      {{key}} - {{value || 'Empty Reason'}}
    </div>
</div>
</template>
<script>
import mixin from './_mixin_display'
export default {
  mixins: [mixin],
  skipBasic: true,
}
</script>